import { __decorate, __param } from '../../../../../../../external/tslib/tslib.es6.js';
import { URI } from 'monaco-editor/esm/vs/base/common/uri.js';
import { AbstractURLService } from '../../../../platform/url/common/urlService.js';
import { IBrowserWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/browser/environmentService';
import { IOpenerService } from 'monaco-editor/esm/vs/platform/opener/common/opener.js';
import { matchesScheme } from 'monaco-editor/esm/vs/base/common/network.js';
import { IProductService } from 'monaco-editor/esm/vs/platform/product/common/productService.js';

class BrowserURLOpener {
    constructor(urlService, productService) {
        this.urlService = urlService;
        this.productService = productService;
    }
    async open(resource, options) {
        if (options?.openExternal) {
            return false;
        }
        if (!matchesScheme(resource, this.productService.urlProtocol)) {
            return false;
        }
        if (typeof resource === 'string') {
            resource = ( URI.parse(resource));
        }
        return this.urlService.open(resource, { trusted: true });
    }
}
let BrowserURLService = class BrowserURLService extends AbstractURLService {
    constructor(environmentService, openerService, productService) {
        super();
        this.provider = environmentService.options?.urlCallbackProvider;
        if (this.provider) {
            this._register(this.provider.onCallback(uri => this.open(uri, { trusted: true })));
        }
        this._register(openerService.registerOpener(( new BrowserURLOpener(this, productService))));
    }
    create(options) {
        if (this.provider) {
            return this.provider.create(options);
        }
        return ( URI.parse('unsupported://'));
    }
};
BrowserURLService = ( __decorate([
    ( __param(0, IBrowserWorkbenchEnvironmentService)),
    ( __param(1, IOpenerService)),
    ( __param(2, IProductService))
], BrowserURLService));

export { BrowserURLService };
